<mat-select
  class="modus-dropdown min-w-16"
  panelClass="modus-dropdown-panel min-w-32"
  [formControl]="localeControl"
  disableRipple
>
  @for (locale of localeList; track locale) {
    <mat-option [value]="locale">{{ locale }}</mat-option>
  }
</mat-select>
